import Vue from 'vue';
import { Component, Prop, Emit } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

import AddTaskCategoryModal from '@/components/add-task-category-modal.vue';
import DisplayOptionsModal from '@/components/display-options-modal.vue';

import { Project } from '@/types/store-types';

const project = namespace('project');
const startpage = namespace('startpage');

@Component({ components: { AddTaskCategoryModal, DisplayOptionsModal } })
export default class NavBar extends Vue {
  private showMe = false;
  private showInactiveProjects = true;
  private searchboxvalue = '';

  @project.Getter('project')
  private project: Project;

  @project.Getter('selectedTasks')
  private selectedTasks: number;

  @project.Action('deleteSelectedTasks')
  private deleteSelectedTasks() {
  }

  @startpage.Action('setSearchstring')
  private setSearchstring(searchstring: string) {
  }

  @startpage.Action('loadProjects')
  private async LoadProjects(activeOnly: boolean) {
  }

  private created() {
    if (!localStorage.showInactiveProjects) {
      localStorage.showInactiveProjects = false;
    }
  }

  private beforeMount() {
    this.showInactiveProjects = localStorage.showInactiveProjects === 'true';
  }

  private showSearch() {
    this.showMe = !this.showMe;
  }

  private showClosedProjects() {
    this.showInactiveProjects = !this.showInactiveProjects;
    localStorage.showInactiveProjects = this.showInactiveProjects;
    this.LoadProjects(this.showInactiveProjects);
  }

  private Refresh() {
    this.LoadProjects(this.showInactiveProjects);
  }
}
